import React, { useRef, useEffect } from 'react';
import '../styles/footer.css'
const Footer = () => {
    let logo = 'https://static.igem.wiki/teams/5066/global/i2024-logo.webp';
    let instagramIcon = 'https://static.igem.wiki/teams/5066/global/instagram-icon.webp';
    let youtubeIcon = 'https://static.igem.wiki/teams/5066/global/youtube-icon.png';
    let mapsIcon = 'https://static.igem.wiki/teams/5066/global/googlemap-icon.png';
    let dengueBeetersLogo = 'https://static.igem.wiki/teams/5066/global/teamlogo.png';
    let callIcon = 'https://static.igem.wiki/teams/5066/global/call-icon.png';
    let mailIcon = 'https://static.igem.wiki/teams/5066/global/mail-icon.png';
    let mapIcon = 'https://static.igem.wiki/teams/5066/global/map-icon.png';
    let DaisyBook = 'https://static.igem.wiki/teams/5066/new/daisybook.jpg';
    let SnapGene = 'https://static.igem.wiki/teams/5066/new/snapgene.png';
    let TwistLogo = 'https://static.igem.wiki/teams/5066/new/twistbioscience.png';
    let idtLogo = 'https://static.igem.wiki/teams/5066/new/logo-idt.png';
    const sliderRef = useRef(null);
    useEffect(() => {
        const slider = sliderRef.current;

        slider.addEventListener('mouseenter', () => {
            slider.style.animationPlayState = 'paused';
        });

        slider.addEventListener('mouseleave', () => {
            slider.style.animationPlayState = 'running';
        });

        return () => {
            slider.removeEventListener('mouseenter', () => { });
            slider.removeEventListener('mouseleave', () => { });
        };
    }, []);
    return (
        <footer className="bg-[#C94C67] text-white py-6 w-full">
            <div className="container mx-auto sm:px-6 md:px-8 lg:px-12 flex flex-col md:flex-row justify-between items-start">
                {/* Left Section */}
                <div className="flex flex-col md:flex-row items-center md:items-start mb-6 md:mb-0 w-full md:w-auto md:justify-start">
                    <img src={logo} alt="GEMS Taiwan 2024 Logo" className="w-16 sm:w-20 md:w-24 h-auto mr-0 md:mr-4" />
                    <div className="text-center md:text-left">
                        <h1 className="text-lg sm:text-xl md:text-2xl font-bold">GEMS - TAIWAN 2024</h1>
                        <p className="mt-1 italic text-sm sm:text-base md:text-lg">When passion and creativity meet synthetic biology.</p>
                        <p className='p-4 font-bold text-center pt-8'>SPONSORS</p>
                        {/* Sponsor Slider */}
                        <div className="logo-slider-wrapper">
                            <div className="logo-slider flex gap-4" ref={sliderRef}>
                                {/* Sponsor Logos */}
                                <div className="sponsor-container">
                                    <img src={SnapGene} alt='SnapGene Logo' className='w-44 h-auto' />
                                </div>
                                <div className="sponsor-container">
                                    <img src={TwistLogo} alt='Twist Logo' className='w-44 h-auto' />
                                </div>
                                <div className="sponsor-container">
                                    <img src={idtLogo} alt='IDT Logo' className='w-44 h-auto pt-4' />
                                </div>
                                <div className="sponsor-container">
                                    <img src='https://static.igem.wiki/teams/5066/freeze/wiadvancelogo.png' alt='Twist Logo' className='w-24 h-auto' />
                                </div>
                                <div className="sponsor-container">
                                    <img src={DaisyBook} alt='DaisyBook' className='w-44 h-auto pt-8' />
                                </div>
                                <div className="sponsor-container">
                                    <img src='https://static.igem.wiki/teams/5066/freeze/gems-photoroom-1.png' alt='SnapGene Logo' className='w-32 pt-4 h-auto' />
                                </div>

                                {/* Duplicated Logos for Infinite Loop */}
                                <div className="sponsor-container">
                                    <img src={SnapGene} alt='SnapGene Logo' className='w-44 h-auto' />
                                </div>
                                <div className="sponsor-container">
                                    <img src={TwistLogo} alt='Twist Logo' className='w-44 h-auto' />
                                </div>
                                <div className="sponsor-container">
                                    <img src={idtLogo} alt='IDT Logo' className='w-44 h-auto pt-4' />
                                </div>
                                <div className="sponsor-container">
                                    <img src='https://static.igem.wiki/teams/5066/freeze/wiadvancelogo.png' alt='Twist Logo' className='w-24 h-auto' />
                                </div>
                                <div className="sponsor-container">
                                    <img src={DaisyBook} alt='DaisyBook' className='w-44 h-auto pt-8' />
                                </div>
                                <div className="sponsor-container">
                                    <img src='https://static.igem.wiki/teams/5066/freeze/gems-photoroom-1.png' alt='SnapGene Logo' className='w-32 pt-4 h-auto' />
                                </div>
                            </div>
                        </div>

                    </div>
                </div>

                {/* Right Section (Responsive Box) */}
                <div className="flex-1 md:pl-6 w-full md:w-auto md:ml-auto p-4">
                    <div className="relative bg-[#FFFEE8] text-black p-6 sm:p-8 md:p-8 rounded-2xl shadow-lg mx-auto md:mx-0 max-w-full md:max-w-xl lg:max-w-2xl md:min-w-[450px] lg:min-w-[500px]">
                        {/* Social Icons */}
                        <div className="mb-4 sm:mb-6 flex justify-center md:justify-start space-x-4">
                            <a href="https://www.instagram.com/gems_taiwan/" className="w-8 sm:w-10 h-8 sm:h-10 bg-[#F1EFDE] rounded-full flex items-center justify-center shadow-md hover:bg-[#D3CFC4] transition-colors duration-300">
                                <img src={instagramIcon} alt="Instagram" className="w-4 sm:w-5 h-auto" />
                            </a>
                            <a href="https://www.youtube.com/@gemstaiwan4743/featured" className="w-8 sm:w-10 h-8 sm:h-10 bg-[#F1EFDE] rounded-full flex items-center justify-center shadow-md hover:bg-[#D3CFC4] transition-colors duration-300">
                                <img src={youtubeIcon} alt="YouTube" className="w-5 sm:w-6 h-auto" />
                            </a>
                            <a href="https://www.google.com/maps/place/GEMS+Academy/@25.0812061,121.5907026,17z/data=!3m2!4b1!5s0x3442ac8cf8dd347f:0xfa2591db33690d07!4m6!3m5!1s0x3442ada919cd3a7d:0x7620850f4694429!8m2!3d25.0812061!4d121.5907026!16s%2Fg%2F11jydlbwkf?entry=ttu&g_ep=EgoyMDI0MDkyOS4wIKXMDSoASAFQAw%3D%3D" className="w-8 sm:w-10 h-8 sm:h-10 bg-[#F1EFDE] rounded-full flex items-center justify-center shadow-md hover:bg-[#D3CFC4] transition-colors duration-300">
                                <img src={mapsIcon} alt="Maps" className="w-4 sm:w-5 h-auto" />
                            </a>
                        </div>

                        {/* Team Logo */}
                        <div className="relative">
                            <img src={dengueBeetersLogo} alt="Dengue Beeters Logo" className="absolute top-0 right-0 transform translate-x-1 -translate-y-1/2 h-16 sm:h-20 md:h-28 w-auto" />
                        </div>

                        {/* Contact Information */}
                        <div className="space-y-4 mt-6 sm:mt-8 text-center md:text-left">
                            <div className="font-bold text-xl sm:text-2xl text-[#6C4E52]">
                                <p>Contact Us!</p>
                            </div>
                            <div className="flex items-center justify-center md:justify-start">
                                <img src={callIcon} alt="call" className="w-4 sm:w-5 h-auto mr-2" />
                                <p><a href="tel:+886287924755" className="text-[#6C4E52] hover:text-[#a87a80] transition-colors duration-300 text-base sm:text-lg">+886 2 87924755</a></p>
                            </div>
                            <div className="flex items-center justify-center md:justify-start">
                                <img src={mailIcon} alt="mail" className="w-4 sm:w-5 h-auto mr-2" />
                                <p><a href="mailto:gems.taiwan@gems.com.tw" className="text-[#6C4E52] hover:text-[#a87a80] transition-colors duration-300 text-base sm:text-lg">gems.taiwan@gems.com.tw</a></p>
                            </div>
                            <div className="flex items-center justify-center md:justify-start">
                                <img src={mapIcon} alt="map" className="w-4 sm:w-5 h-auto mr-2" />
                                <p className="text-[#6C4E52] hover:text-[#a87a80] transition-colors duration-300 text-base sm:text-lg">2F.-1, No. 15, Ln. 174, Sec. 3, Chenggong Rd., Neihu Dist., Taipei, Taiwan (R.O.C.)</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Footer Bottom */}
            <div className="bg-[#C94C67] text-center text-white p-3 w-full">
                <hr className="border-white p-2" />
                <div className="text-xs sm:text-sm">
                    <p>© 2024 Content on this site is licensed under a <a href="https://creativecommons.org/licenses/by/4.0/" className="text-white hover:text-[#edc1e5] transition-colors duration-300">Creative Commons Attribution 4.0 International license</a>.
                        <br />
                        The repository used to create this website is available at <a href="https://gitlab.igem.org/2024/gems-taiwan" className="text-white hover:text-[#edc1e5] transition-colors duration-300">https://gitlab.igem.org/2024/gems-taiwan</a>.
                    </p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
